module.exports = __webpack_public_path__ + "d3e9f2bd9e2675b25a6efe28d94fecbb.jpg";